import React from 'react';
import './Card.css';

/**
 * Card Component
 * Container for content sections
 */
const Card = ({
  children,
  title,
  subtitle,
  headerActions,
  padding = true,
  hoverable = false,
  className = '',
  ...props
}) => {
  const classNames = [
    'card',
    hoverable ? 'card-hoverable' : '',
    padding ? '' : 'card-no-padding',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classNames} {...props}>
      {(title || headerActions) && (
        <div className="card-header">
          <div className="card-header-content">
            {title && <h3 className="card-title">{title}</h3>}
            {subtitle && <p className="card-subtitle">{subtitle}</p>}
          </div>
          {headerActions && (
            <div className="card-header-actions">
              {headerActions}
            </div>
          )}
        </div>
      )}
      <div className="card-body">
        {children}
      </div>
    </div>
  );
};

// Card subcomponents
Card.Header = ({ children, className = '' }) => (
  <div className={`card-header ${className}`}>{children}</div>
);

Card.Body = ({ children, className = '' }) => (
  <div className={`card-body ${className}`}>{children}</div>
);

Card.Footer = ({ children, className = '' }) => (
  <div className={`card-footer ${className}`}>{children}</div>
);

export default Card;